export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11463.26b34f98.jpg";